"use strict";
//@ts-nocheck
/**
 * Special login form behaviour w/ validation & callbacks
 *
 * NOTE hardcorded quick win version
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.login = {
    // Login action URLs
    actionUrl: '',
    actionUrlLightbox: '',
    actionUrlJson: '',
    // Login status
    isLoggedIn: false,
    name: '',
    company: '',
    /**
     * Things which have to be updated on each callback
     */
    update: function () {
        $('.login-form-container form input:text,input:password').attr('autocomplete', 'off');
        _main_1.txGs1Base.login.pollStatus();
        _main_1.txGs1Base.login.bindErrorHandling();
    },
    /**
     * Poll login status
     * and store in variable
     */
    pollStatus: function () {
        if (!_main_1.txGs1Base.login.actionUrlJson) {
            _main_1.txGs1Base.login.actionUrlJson = $('[data-status-url]').attr('data-status-url');
        }
        $.ajax({
            url: _main_1.txGs1Base.login.actionUrlJson,
            dataType: "json",
            cache: false,
            success: function (statusInformation) {
                _main_1.txGs1Base.login.isLoggedIn = statusInformation.isLoggedIn;
                if (statusInformation.isLoggedIn) {
                    $('body').addClass('mw-logged-in');
                }
                else {
                    $('body').removeClass('mw-logged-in');
                }
                _main_1.txGs1Base.login.name = statusInformation.name;
                _main_1.txGs1Base.login.company = statusInformation.company;
                _main_1.txGs1Base.login.setNameAndCompany();
                //  callback function
                if (typeof _main_1.txGs1Base.login.pollLoginCallback === 'function') {
                    _main_1.txGs1Base.login.pollLoginCallback.call(this);
                }
            }
        });
    },
    setNameAndCompany: function () {
        $('.login-form-container .name').text(_main_1.txGs1Base.login.name);
        $('.login-form-container .company').text(_main_1.txGs1Base.login.company);
    },
    /**
     * Process FE login
     */
    sendLoginRequest: function (formEl) {
        _main_1.txGs1Base.activityIndicator.attach();
        var $form = $(formEl);
        var $formContainer = $form.closest('.login-form-container');
        var params = $form.serialize();
        var url = $formContainer.hasClass('login-form-container__lightbox') ? _main_1.txGs1Base.login.actionUrlLightbox : _main_1.txGs1Base.login.actionUrl;
        $.ajax({
            type: 'post',
            url: url,
            data: params,
            cache: false,
            success: function (response) {
                if (response.action === 'redirect' && response.redirectUrl !== '') {
                    _main_1.txGs1Base.activityIndicator.detach();
                    window.location.href = response.redirectUrl;
                }
                else {
                    if (typeof _main_1.txGs1Base.login.actionCallback === 'function') {
                        _main_1.txGs1Base.login.actionCallback.call(this, response.message);
                    }
                    else {
                        var $deviantForm = $('.fancybox-inner').find('form#tx_mwlogin_login_deviant');
                        if ($deviantForm.length > 0) {
                            $deviantForm.closest('.login-form-container').replaceWith($('.login-form-container', response));
                        }
                        else {
                            $formContainer.replaceWith(response);
                            // Set login status and parse response for error message div
                            let loginSuccess = false;
                            let position = response.search("error-message");
                            if (position <= 0) {
                                loginSuccess = true;
                            }
                            if (loginSuccess === true) {
                                $('#user-login-status').addClass('btn--user-logged-in');
                            }
                        }
                        // Reselect replaced login form or you will get data from first form sending - GSONE-1256
                        _main_1.txGs1Base.login.context = $(_main_1.txGs1Base.login.classname);
                        _main_1.txGs1Base.login.update();
                    }
                    if (typeof _main_1.txGs1Base.login.trackingCallback === 'function') {
                        _main_1.txGs1Base.login.trackingCallback.call(this, response.message);
                    }
                    _main_1.txGs1Base.activityIndicator.detach();
                }
            }
        });
    },
    setFormContent: function ($formContainer, html) {
        // Replace the form with the submission response
        $formContainer.replaceWith(html);
        _main_1.txGs1Base.login.update();
        // Update other login forms to be up to date
        $.ajax({
            url: _main_1.txGs1Base.login.actionUrl,
            cache: false,
            success: function (otherHtml) {
                $('.login-form-container-normal').
                    not('[data-has-latest-used-login-box] .login-form-container-normal').
                    replaceWith(otherHtml);
                _main_1.txGs1Base.login.update();
            }
        });
    },
    bindErrorHandling: function () {
        let validatingInputs = Array.from(document.querySelectorAll('[data-validation]'));
        validatingInputs.forEach((item) => {
            item.addEventListener("invalid", () => {
                item.closest('.form-group').classList.add('has-error');
                let errorMsg = document.createElement('span');
                errorMsg.classList.add('error-message');
                errorMsg.append(item.getAttribute('data-error-msg'));
                item.closest('.form-group').appendChild(errorMsg);
            });
            item.addEventListener("input", (event) => {
                item.closest('.form-group').classList.remove('has-error');
                if (item.nextElementSibling)
                    item.nextElementSibling.remove();
            });
        });
    },
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.login.update();
        let $body = $('body');
        let actionUrl = $('form.login-register-box').attr('action');
        _main_1.txGs1Base.login.actionUrl = actionUrl + 'loginform.html';
        _main_1.txGs1Base.login.actionUrlLightbox = actionUrl + 'loginlightbox.html';
        _main_1.txGs1Base.login.actionUrlJson = actionUrl + 'loginstatus.json';
        // prevents multiple binding, quick-fix for GSONE-939
        $body.off('submit', '.login-form-container form');
        $body.on('submit', '.login-form-container form', function (event) {
            event.preventDefault();
            let $form = $(this);
            // set local context to identify WHICH form is used
            let $parent = $('.login-form-container').parent();
            $parent.removeAttr('data-has-latest-used-login-box');
            $parent.each(function (index, item) {
                let $item = $(item);
                if ($item.find($form).length > 0) {
                    $item.attr('data-has-latest-used-login-box', '1');
                }
            });
            _main_1.txGs1Base.login.sendLoginRequest(this);
        });
        // see GSONE-764
        let $loginElementInContentArea = $('.content-module__login > .login-form-container-normal');
    }
};
exports.default = {};
